export const menuAssociate = {
    menu: [
        {
            label: 'menu.listeDesDossiers',
            url: '/datavis/dossiers',
            children: []
        },
        {
            label: 'menu.mesExpertises',
            url: '/dossiers/mes-expertises',
            children: []
        },
    ],
    classKey: 'expert'
};
